import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GlossaryHtmlService } from '../services/glossary-html.service';

@Pipe({
    name: 'glossaryTooltip',
    standalone: false
})
export class GlossaryTooltipPipe implements PipeTransform {
  constructor(
    private readonly glossaryHtmlService: GlossaryHtmlService) {
  }

  transform(value: string, element: HTMLElement, enabled: boolean): Observable<string> {
    return !enabled ? of(value) : this.glossaryHtmlService.applyGlossaryTooltipsToHtml(value, element);
  }
}
